import * as Animations from "./helpers/Animations.js";
import Utils from "./helpers/Utils.js";
import Scroll from "./components/Scroll.js";
import Header from "./components/Header.js";
import Spollers from "./components/Spollers.js";
import { api } from "./services/ApiService.js";
import PostsLoader from "./components/PostsLoader.js";
import PostsFilter from "./components/PostsFilter.js";
import Fancybox from "./components/Fancybox.js";
import ClipboardCopy from "./components/ClipboardCopy.js";
import Tabs from "./components/Tabs.js";
import SwiperSlider from "./components/SwiperSlider";

/**
 * Функція для ініціалізації всіх компонентів
 *
 * @typedef {Object} GlobalDeps
 * @typedef {Object} options
 */
const AGDSApp = () => {
    // Start Loader
    window.addEventListener("load", () => {
        document.body.classList.add("_show");
    });

    // Змінні
    const options = {
        windowWidth: window.innerWidth || document.documentElement.clientWidth,
        overlay: document.getElementById("overlay"),
        preloader: document.getElementById("preloader"),
        header: document.getElementById("header"),
        fancyBtns: document.querySelectorAll("[data-fancybox]"),
        postsContainer: document.getElementById("posts-container"),
        spollers: document.querySelectorAll("[data-spollers]"),
        tabLists: document.querySelectorAll("[role='tablist']"),
        copies: document.querySelectorAll("[data-copy]"),
        swiperEls: document.querySelectorAll(".swiper"),
    };

    // Utils
    const utils = document.body ? new Utils() : null;

    // Scroll
    const scroll = document.body
        ? new Scroll({
              windowWidth: options.windowWidth,
              header: options.header,
          })
        : null;

    // Header
    const header = options.header
        ? new Header({
              windowWidth: options.windowWidth,
              animations: Animations,
              header: options.header,
          })
        : null;

    // PostLoader
    const postsLoader = options.postsContainer
        ? new PostsLoader({
              windowWidth: options.windowWidth,
              preloader: options.preloader,
              api: api,
              postsContainer: options.postsContainer,
          })
        : null;

    // Spollers
    const spollers = options.spollers ? new Spollers() : null;

    // Tabs
    if (options.tabLists && options.tabLists.length > 0) {
        options.tabLists.forEach((tabList) => {
            const container = tabList.parentElement;

            // Запобігаємо повторній ініціалізації
            if (!container.hasAttribute("data-tabs-initialized")) {
                new Tabs(container);
                container.setAttribute("data-tabs-initialized", "true");
            }
        });
    }

    // Clipboard
    const clipboardCopy = options.copies ? new ClipboardCopy() : null;

    // Modals
    const modals = options.fancyBtns ? new Fancybox() : null;

    // Swiper
    const swiper = options.swiperEls.length
        ? new SwiperSlider({
              windowWidth: options.windowWidth,
              swiperEls: options.swiperEls,
          })
        : null;

    // Ініціалізація модулів
    utils?.init();
    scroll?.init();
    header?.init();
    postsLoader?.init();
    spollers?.init();
    clipboardCopy?.init();
    modals?.init();
    swiper?.init();
};

// Запуск програми після повного завантаження DOM
document.addEventListener("DOMContentLoaded", AGDSApp);
